import { call, takeEvery } from 'redux-saga/effects';

import {
  TRACK_PROJECT_STYLE_CHANGED,
  TRACK_PROJECT_STYLE_REMOVED,
  TRACK_PROJECT_STYLE_SELECTED,
  TrackProjectStyleChangedAction,
  TrackProjectStyleSelectedAction
} from 'js/actionCreators/trackingActions';

import { track } from '../mixpanelProvider';

function* trackProjectStyleSelected({ styleName }: TrackProjectStyleSelectedAction) {
  yield call(track, 'Project Style Selected', { 'Style Name': styleName });
}

function* trackProjectStyleChanged({ previousStyle, newStyle }: TrackProjectStyleChangedAction) {
  yield call(track, 'Project Style Changed', { 'Previous Style': previousStyle, 'New Style': newStyle });
}

function* trackProjectStyleRemoved() {
  yield call(track, 'Project Style Removed');
}

export default function* trackStyleSelectorSagas() {
  yield takeEvery(TRACK_PROJECT_STYLE_SELECTED, trackProjectStyleSelected);
  yield takeEvery(TRACK_PROJECT_STYLE_CHANGED, trackProjectStyleChanged);
  yield takeEvery(TRACK_PROJECT_STYLE_REMOVED, trackProjectStyleRemoved);
}
